import {useEffect, useState} from 'react';

export function useHasSmallSidebar() {
    const [hasSmallSidebar, setHasSmallSidebar] = useState(
        () => window.matchMedia(`(max-width: 1450px)`).matches
    );

    useEffect(() => {
        // 1450px matches the breakpoint in core-entity-sidebar.module.css
        const mediaQuery = window.matchMedia('(max-width: 1450px)');

        const handleChange = (event: MediaQueryListEvent) => {
            setHasSmallSidebar(event.matches);
        };

        mediaQuery.addEventListener('change', handleChange);

        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);

    return hasSmallSidebar;
}
